module.exports = __webpack_public_path__ + "static/media/grunwald.94fc2d1d.png";